import React, { useState, useEffect, useRef, useContext, useMemo } from "react";

import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import UserService from "services/UserService";
import Chip from "@mui/material/Chip";
import AdvancedSearchContext from "context/AdvancedSearchContext";

import { site } from "variables/patrimoine.js";
import { getSite, getFiles } from "services/ConfigServices";
import { makeStyles } from "@mui/styles";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


function Synthesis(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [pv, setPv] = useState(false);
  const [solarthermal, setSolarthermal] = useState(false);
  const [biomass, setBiomass] = useState(false);
  const [geothermal, setGeothermal] = useState(false);
  const [other, setOther] = useState([]);
  const [pvrooforientation, setPvrooforientation] = useState("");
  const [pvrooftilt, setPvrooftilt] = useState("");
  const [pvroofsurface, setPvroofsurface] = useState("");
  const [pvsolarmask, setPvsolarmask] = useState("");
  const [pvheatingcompatibility, setPvheatingcompatibility] = useState("");
  const [pvfaisability, setPvfaisability] = useState("");
  const [solarthermalrooforientation, setSolarthermalrooforientation] = useState("");
  const [solarthermalrooftilt, setSolarthermalrooftilt] = useState("");
  const [solarthermalroofsurface, setSolarthermalroofsurface] = useState("");
  const [solarthermalsolarmask, setSolarthermalsolarmask] = useState("");
  const [solarthermalheatingcompatibility, setSolarthermalheatingcompatibility] = useState("");
  const [solarthermalsuitability, setSolarthermalsuitability] = useState("");
  const [solarthermalfaisability, setSolarthermalfaisability] = useState("");
  const [biomassgroundavailablesurface, setBiomassgroundavailablesurface] = useState("");
  const [biomassdeliverycapacity, setBiomassdeliverycapacity] = useState("");
  const [biomasssilocapacity, setBiomasssilocapacity] = useState("");
  const [biomassheatingcompatibility, setBiomassheatingcompatibility] = useState("");
  const [biomassfaisability, setBiomassfaisability] = useState("");
  const [geothermalgroundavailablesurface, setGeothermalgroundavailablesurface] = useState("");
  const [geothermalgroundtype, setGeothermalgroundtype] = useState("");
  const [geothermalcompatibility, setGeothermalcompatibility] = useState("");
  const [geothermalfaisability, setGeothermalfaisability] = useState("");
  const [associatedfiles, setAssociatedfiles] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);


  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handlePvChange = (event) => { setPv(!pv); };
  const handleSolarthermalChange = (event) => { setSolarthermal(!solarthermal); };
  const handleBiomassChange = (event) => { setBiomass(!biomass); };
  const handleGeothermalChange = (event) => { setGeothermal(!geothermal); };
  const handleOtherChange = (newValue) => { setOther(newValue); };
  const handlePvrooforientationChange = (event) => { setPvrooforientation(event.target.value); };
  const handlePvrooftiltChange = (event) => { setPvrooftilt(event.target.value); };
  const handlePvroofsurfaceChange = (event) => { setPvroofsurface(event.target.value); };
  const handlePvsolarmaskChange = (event) => { setPvsolarmask(event.target.value); };
  const handlePvheatingcompatibilityChange = (event) => { setPvheatingcompatibility(event.target.value); };
  const handlePvfaisabilityChange = (event) => { setPvfaisability(event.target.value); };
  const handleSolarthermalrooforientationChange = (event) => { setSolarthermalrooforientation(event.target.value); };
  const handleSolarthermalrooftiltChange = (event) => { setSolarthermalrooftilt(event.target.value); };
  const handleSolarthermalroofsurfaceChange = (event) => { setSolarthermalroofsurface(event.target.value); };
  const handleSolarthermalsolarmaskChange = (event) => { setSolarthermalsolarmask(event.target.value); };
  const handleSolarthermalheatingcompatibilityChange = (event) => { setSolarthermalheatingcompatibility(event.target.value); };
  const handleSolarthermalsuitabilityChange = (event) => { setSolarthermalsuitability(event.target.value); };
  const handleSolarthermalfaisabilityChange = (event) => { setSolarthermalfaisability(event.target.value); };
  const handleBiomassgroundavailablesurfaceChange = (event) => { setBiomassgroundavailablesurface(event.target.value); };
  const handleBiomassdeliverycapacityChange = (event) => { setBiomassdeliverycapacity(event.target.value); };
  const handleBiomasssilocapacityChange = (event) => { setBiomasssilocapacity(event.target.value); };
  const handleBiomassheatingcompatibilityChange = (event) => { setBiomassheatingcompatibility(event.target.value); };
  const handleBiomassfaisabilityChange = (event) => { setBiomassfaisability(event.target.value); };
  const handleGeothermalgroundavailablesurfaceChange = (event) => { setGeothermalgroundavailablesurface(event.target.value); };
  const handleGeothermalgroundtypeChange = (event) => { setGeothermalgroundtype(event.target.value); };
  const handleGeothermalcompatibilityChange = (event) => { setGeothermalcompatibility(event.target.value); };
  const handleGeothermalfaisabilityChange = (event) => { setGeothermalfaisability(event.target.value); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociatedfiles(newArray);
  };
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  
  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "renewables.synthesis"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPv(res.data.detail.renewables.synthesis?.pv);
        setSolarthermal(res.data.detail.renewables.synthesis?.solarthermal);
        setBiomass(res.data.detail.renewables.synthesis?.biomass);
        setGeothermal(res.data.detail.renewables.synthesis?.geothermal);
        setOther(res.data.detail.renewables.synthesis?.other || []);
        setPvrooforientation(res.data.detail.renewables.synthesis?.pvrooforientation);
        setPvrooftilt(res.data.detail.renewables.synthesis?.pvrooftilt);
        setPvroofsurface(res.data.detail.renewables.synthesis?.pvroofsurface);
        setPvsolarmask(res.data.detail.renewables.synthesis?.pvsolarmask);
        setPvheatingcompatibility(res.data.detail.renewables.synthesis?.pvheatingcompatibility);
        setPvfaisability(res.data.detail.renewables.synthesis?.pvfaisability);
        setSolarthermalrooforientation(res.data.detail.renewables.synthesis?.solarthermalrooforientation);
        setSolarthermalrooftilt(res.data.detail.renewables.synthesis?.solarthermalrooftilt);
        setSolarthermalroofsurface(res.data.detail.renewables.synthesis?.solarthermalroofsurface);
        setSolarthermalsolarmask(res.data.detail.renewables.synthesis?.solarthermalsolarmask);
        setSolarthermalheatingcompatibility(res.data.detail.renewables.synthesis?.solarthermalheatingcompatibility);
        setSolarthermalsuitability(res.data.detail.renewables.synthesis?.solarthermalsuitability);
        setSolarthermalfaisability(res.data.detail.renewables.synthesis?.solarthermalfaisability);
        setBiomassgroundavailablesurface(res.data.detail.renewables.synthesis?.biomassgroundavailablesurface);
        setBiomassdeliverycapacity(res.data.detail.renewables.synthesis?.biomassdeliverycapacity);
        setBiomasssilocapacity(res.data.detail.renewables.synthesis?.biomasssilocapacity);
        setBiomassheatingcompatibility(res.data.detail.renewables.synthesis?.biomassheatingcompatibility);
        setBiomassfaisability(res.data.detail.renewables.synthesis?.biomassfaisability);
        setGeothermalgroundavailablesurface(res.data.detail.renewables.synthesis?.geothermalgroundavailablesurface);
        setGeothermalgroundtype(res.data.detail.renewables.synthesis?.geothermalgroundtype);
        setGeothermalcompatibility(res.data.detail.renewables.synthesis?.geothermalcompatibility);
        setGeothermalfaisability(res.data.detail.renewables.synthesis?.geothermalfaisability);
        setAssociatedfiles(res.data.detail.renewables.synthesis?.associatedfiles || []);
        setComments(res.data.detail.renewables.synthesis?.comments);
        setDescription(res.data.detail.renewables.synthesis?.description);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "renewables.synthesis"),
        {
          pv,
          solarthermal,
          biomass,
          geothermal,
          other,
          pvrooforientation,
          pvrooftilt,
          pvroofsurface,
          pvsolarmask,
          pvheatingcompatibility,
          pvfaisability,
          solarthermalrooforientation,
          solarthermalrooftilt,
          solarthermalroofsurface,
          solarthermalsolarmask,
          solarthermalheatingcompatibility,
          solarthermalsuitability,
          solarthermalfaisability,
          biomassgroundavailablesurface,
          biomassdeliverycapacity,
          biomasssilocapacity,
          biomassheatingcompatibility,
          biomassfaisability,
          geothermalgroundavailablesurface,
          geothermalgroundtype,
          geothermalcompatibility,
          geothermalfaisability,
          associatedfiles,
          comments,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();
  const autocompleteOptions = [];
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <CustomSwitch
              inputTitle={site.renewables.synthesis.pv}
              checkedState={pv}
              handleSwitchChange={handlePvChange}
              disabled={!realestateupdate}
            />
          </div>
          
          {pv ? <div>
            <div>
            <TextInput
              inputTitle={site.renewables.synthesis.pvrooforientation}
              textInput={pvrooforientation}
              handleTextInputChange={handlePvrooforientationChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.pvrooftilt}
              textInput={pvrooftilt}
              handleTextInputChange={handlePvrooftiltChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.pvroofsurface}
              textInput={pvroofsurface}
              handleTextInputChange={handlePvroofsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.pvsolarmask}
              textInput={pvsolarmask}
              handleTextInputChange={handlePvsolarmaskChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.pvheatingcompatibility}
              textInput={pvheatingcompatibility}
              handleTextInputChange={handlePvheatingcompatibilityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.pvfaisability}
              textInput={pvfaisability}
              handleTextInputChange={handlePvfaisabilityChange}
              disabled={!realestateupdate}
            />
          </div></div> : <></>}
          <div>
            <CustomSwitch
              inputTitle={site.renewables.synthesis.solarthermal}
              checkedState={solarthermal}
              handleSwitchChange={handleSolarthermalChange}
              disabled={!realestateupdate}
            />
          </div>
          {solarthermal ? <div>
            <div>
            <TextInput
              inputTitle={site.renewables.synthesis.solarthermalrooforientation}
              textInput={solarthermalrooforientation}
              handleTextInputChange={handleSolarthermalrooforientationChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.solarthermalrooftilt}
              textInput={solarthermalrooftilt}
              handleTextInputChange={handleSolarthermalrooftiltChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.solarthermalroofsurface}
              textInput={solarthermalroofsurface}
              handleTextInputChange={handleSolarthermalroofsurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.solarthermalsolarmask}
              textInput={solarthermalsolarmask}
              handleTextInputChange={handleSolarthermalsolarmaskChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.solarthermalheatingcompatibility}
              textInput={solarthermalheatingcompatibility}
              handleTextInputChange={handleSolarthermalheatingcompatibilityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.solarthermalsuitability}
              textInput={solarthermalsuitability}
              handleTextInputChange={handleSolarthermalsuitabilityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.solarthermalfaisability}
              textInput={solarthermalfaisability}
              handleTextInputChange={handleSolarthermalfaisabilityChange}
              disabled={!realestateupdate}
            />
          </div></div> : <></>}
          <div>
            <CustomSwitch
              inputTitle={site.renewables.synthesis.biomass}
              checkedState={biomass}
              handleSwitchChange={handleBiomassChange}
              disabled={!realestateupdate}
            />
          </div>
          {biomass ? <div>
            <div>
            <TextInput
              inputTitle={site.renewables.synthesis.biomassgroundavailablesurface}
              textInput={biomassgroundavailablesurface}
              handleTextInputChange={handleBiomassgroundavailablesurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.biomassdeliverycapacity}
              textInput={biomassdeliverycapacity}
              handleTextInputChange={handleBiomassdeliverycapacityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.biomasssilocapacity}
              textInput={biomasssilocapacity}
              handleTextInputChange={handleBiomasssilocapacityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.biomassheatingcompatibility}
              textInput={biomassheatingcompatibility}
              handleTextInputChange={handleBiomassheatingcompatibilityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.biomassfaisability}
              textInput={biomassfaisability}
              handleTextInputChange={handleBiomassfaisabilityChange}
              disabled={!realestateupdate}
            />
          </div></div> : <></>}
          <div>
            <CustomSwitch
              inputTitle={site.renewables.synthesis.geothermal}
              checkedState={geothermal}
              handleSwitchChange={handleGeothermalChange}
              disabled={!realestateupdate}
            />
          </div>
          {geothermal ? <div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.geothermalgroundavailablesurface}
              textInput={geothermalgroundavailablesurface}
              handleTextInputChange={handleGeothermalgroundavailablesurfaceChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.geothermalgroundtype}
              textInput={geothermalgroundtype}
              handleTextInputChange={handleGeothermalgroundtypeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.geothermalcompatibility}
              textInput={geothermalcompatibility}
              handleTextInputChange={handleGeothermalcompatibilityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.geothermalfaisability}
              textInput={geothermalfaisability}
              handleTextInputChange={handleGeothermalfaisabilityChange}
              disabled={!realestateupdate}
            />
          </div></div> : <></>}
          <div>
            <AutocompleteTagsInput
              inputTitle={site.renewables.synthesis.other}
              list={autocompleteOptions}
              selected={other}
              handleChange={handleOtherChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <AutocompleteInput
              disabled={!realestateupdate}
              inputTitle={site.renewables.synthesis.associatedfiles}
              selected={selectedGed()}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociatedfilesChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={site.renewables.synthesis.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

export default Synthesis;